import AuthPageLayout from "./AuthPageLayout";

export default function AuthLayout({ children }) {
  return (
    <AuthPageLayout>
      <div className="glass-panel page-fade relative w-full overflow-hidden rounded-2xl p-6">{children}</div>
    </AuthPageLayout>
  );
}
